import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import "./experiencia.scss"

export const ExperienciaSection = () => {
  return (
    <>
      <section className="servicios-experiencia-container">
        <div
          className="servicios-experiencia-images-container"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <StaticImage
            src="../../../../images/servicios/experiencia/Cuadrados-estitica-derechos-escritorio.svg"
            className="servicios-icon1"
            alt="cuadrados1"
          />
          <StaticImage
            src="../../../../images/servicios/experiencia/equipo.png"
            className="servicios-experiencia-image1"
            alt="experiencia imagen 1"
          />
          <StaticImage
            src="../../../../images/servicios/experiencia/tecnicos.png"
            className="servicios-experiencia-image2"
            alt="experiencia imagen 2"
          />
        </div>
        <div
          className="servicios-experiencia-info-container"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <div className="servicios-experiencia-info-text">
            <h2>
              Tenemos una larga experiencia de más de
              <span> 16 años en el sector audiovisual</span>
            </h2>
            <p>
              Somos una empresa puntera en la elaboración de proyectos,
              estudios, instalaciones, eventos, etc., trabajando para empresas e
              instituciones de primer orden.
            </p>
          </div>
          <div className="icon2-container">
            <StaticImage
              src="../../../../images/servicios/experiencia/Cuadrados-estitica-izquierdos-escritorio.svg"
              className="servicios-icon2"
              alt="cuadrados2"
            />
          </div>
        </div>
      </section>
    </>
  )
}
